import React from 'react'
import { Link } from 'react-router-dom'

const features = [
  { title: 'KI-Mastering', desc: 'Automatische Lautheit, Limiter und QC nach Spotify, Tidal oder Radio.', icon: '♪' },
  { title: 'Cover-Art', desc: 'KI-generierte Covers mit Typografie und optionalem Branding.', icon: '◇' },
  { title: 'Spotify Canvas', desc: 'Kurze Loop-Videos oder KI-Videos für Spotify Canvas.', icon: '◷' },
]

export default function Landing() {
  return (
    <div className="min-h-screen bg-studio-bg text-white safe-area-padding">
      <header className="sticky top-0 z-30 border-b border-white/10 bg-studio-bg/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4">
          <Link to="/" className="flex items-center gap-2 font-semibold text-white hover:opacity-90">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-violet-500 to-pink-500 text-sm shadow-glow">◇</span>
            AI Mastering Studio
          </Link>
          <nav className="flex items-center gap-2 sm:gap-3">
            <Link to="/forgot-password" className="hidden sm:inline rounded-xl px-3 py-2 text-sm text-white/60 hover:text-white/90">Passwort vergessen?</Link>
            <Link to="/login" className="rounded-xl border border-white/20 px-4 py-2.5 text-sm font-medium text-white/90 hover:bg-white/10 transition">Anmelden</Link>
            <Link to="/register" className="rounded-xl bg-gradient-to-r from-violet-600 to-pink-600 px-4 py-2.5 text-sm font-medium text-white shadow-lg hover:opacity-95 transition">Registrieren</Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-16 sm:py-24">
        <section className="text-center">
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl">
            <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">KI-gestütztes Audio-Mastering</span>
          </h1>
          <p className="mt-6 max-w-2xl mx-auto text-lg text-white/70">
            Professionelle Masters für Spotify, Tidal, Radio – mit automatischer QC und optionalem KI-Cover sowie Spotify Canvas.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link to="/login" className="btn-gradient min-h-[48px] rounded-xl px-8 py-3 text-base font-medium">Zum Mastering</Link>
            <Link to="/register" className="rounded-xl border border-white/20 bg-white/5 px-8 py-3 text-base font-medium text-white hover:bg-white/10">Kostenlos starten</Link>
          </div>
        </section>
        <section className="mt-24 grid gap-8 sm:grid-cols-3">
          {features.map((f) => (
            <div key={f.title} className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur hover:border-white/20 transition">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-violet-500/30 to-pink-500/30 text-2xl">{f.icon}</div>
              <h3 className="mt-4 text-lg font-semibold text-white">{f.title}</h3>
              <p className="mt-2 text-sm text-white/70">{f.desc}</p>
            </div>
          ))}
        </section>
        <section className="mt-24 rounded-2xl border border-white/10 bg-white/5 p-8 text-center">
          <h2 className="text-xl font-bold text-white">Preise</h2>
          <p className="mt-2 text-white/70">Aktuell kostenlose Beta. Später: Credits pro Job. 1 Credit = 1 Mastering-Job.</p>
        </section>
      </main>
      <footer className="mt-24 border-t border-white/10 py-8">
        <div className="mx-auto max-w-6xl px-4 flex flex-wrap justify-between items-center gap-4 text-sm text-white/50">
          <span>© AI Mastering Studio</span>
          <div className="flex flex-wrap items-center gap-4">
            <span className="text-white/40">Nur transaktionale E-Mails (z. B. Passwort-Reset).</span>
            <Link to="/datenschutz" className="hover:text-white/80">Datenschutz</Link>
            <Link to="/impressum" className="hover:text-white/80">Impressum</Link>
          </div>
        </div>
      </footer>
    </div>
  )
}
